/* FERRY AUTO-GENERATED: DO NOT EDIT THIS FILE */ /* eslint-disable */ // @ts-nocheck
import * as api from "../../../api";
import * as sample from "../sample";
import * as homepage_message_tag from "./homepage_message_tag";
import * as common from "./common";
import * as oec_affiliate_creator_marketplace_api from "../../serv/oec_affiliate_creator_marketplace_api";
export { api, sample, homepage_message_tag, common, oec_affiliate_creator_marketplace_api };
export var Gender = {
  GENDER_UNSPECIFIED: 0,
  MALE: 1,
  FEMALE: 2
};
export var AgeGroup = {
  AgeGroup_AGE_GROUP_18_24: 1,
  AgeGroup_AGE_GROUP_25_34: 2,
  AgeGroup_AGE_GROUP_GT_34: 3
};
export var AnnouncementFilterFlag = {
  FILTER_UNREAD: 1,
  FILTER_FAVOR: 2
};
export var Direction = {
  PREV_PAGE: 1,
  NEXT_PAGE: 2
};
export var MsgReadStatus = {
  STATUS_UNREAD: 0,
  STATUS_READ: 1
};
export var MessageType = {
  DEFAULT: 0,
  ANNOUNCEMENT: 1,
  RULE: 2,
  SHOP: 3,
  IMPORTANT: 4,
  POPUP: 8
};
export var BizID = {
  BIZ_SELLER_PLATFORM: 1,
  BIZ_AFFILIATE_PLATFORM: 2,
  BIZ_SUPPLY_CHAIN_PLATFORM: 3,
  BIZ_PARTNER_PLATFORM: 4
};
export var CMSCategoryType = {
  CMS_CATEGORY_BANNER: 1,
  CMS_CATEGORY_TOAST: 2,
  CMS_CATEGORY_POPUP: 3,
  CMS_CATEGORY_OTHERS: 4
};
export var CMSCampaignStatus = {
  CMS_CAMPAIGN_DRAFT: 1,
  CMS_CAMPAIGN_PENDING: 2,
  CMS_CAMPAIGN_REJECTED: 3,
  CMS_CAMPAIGN_PRE_OCCUPIED_REVIEW: 4,
  CMS_CAMPAIGN_PRE_OCCUPIED: 5,
  CMS_CAMPAIGN_TO_BE_ONLINE: 6,
  CMS_CAMPAIGN_ONLINE: 7,
  CMS_CAMPAIGN_OFFLINE: 8,
  CMS_CAMPAIGN_RECALLED: 9,
  CMS_CAMPAIGN_DELETED: 10,
  CMS_CAMPAIGN_DMP_PROCESSING: 11,
  CMS_CAMPAIGN_DMP_FAILED: 12,
  CMS_CAMPAIGN_CATEGORY_NOT_READY: 13
};
export var CMSOrientation = {
  CMS_ORIENTATION_ALL: 1,
  CMS_ORIENTATION_DMP: 2
};
export var CMSAccountType = {
  CMS_SELLER: 1,
  CMS_CREATOR: 2
};